import { GET_GROUP_LI, GET_GROUP_LI_DATA } from '../constants';
import { updateObject, createReducer } from './common';

export const initialState = { 
    dlGroupN: []    
};

const handler = {
    [GET_GROUP_LI]: (state) => updateObject(state, { dlGroupN: [] }),
    [GET_GROUP_LI_DATA]: (state, action) => updateObject(state, { dlGroupN: action.payload })
}

export const dlGroupLiReducer = createReducer(initialState, handler);
